import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["wrapper", "image", "body"];

  connect() {
    window.addEventListener("load", () => this.compareHeights());

    window.addEventListener("resize", () => this.compareHeights());
    
    if (document.readyState === "complete") {
      this.compareHeights();
    }
  }

  compareHeights() {
    if (!this.hasImageTarget || !this.hasBodyTarget) return;
    
    const imageHeight = this.imageTarget.offsetHeight;
    const bodyHeight = this.bodyTarget.offsetHeight;
    const wrapper = this.wrapperTarget;
    const image = this.imageTarget;
    const body = this.bodyTarget;
    
    
    if (imageHeight > bodyHeight) {
        wrapper.classList.remove("overflow-hidden");
        
        image.classList.remove("float-left");
        image.classList.remove("w-full");

        wrapper.classList.add("flex");
        wrapper.classList.add("md:flex-row");
        wrapper.classList.add("flex-col");
        wrapper.classList.add("items-center");
        wrapper.classList.add("space-between");
        wrapper.classList.add("w-full");

        body.style.width = '50%'
    } else if (bodyHeight > imageHeight) {
      this.element.classList.add("body-taller");
    } else {
      this.element.classList.add("heights-equal");
    }
  }
}
